const { NZ_BACKOFFICE_BACK_URL, NZ_CORE_SERVICES_REST_URL } = import.meta.env;

const dev = {
  USERNAME_EXIST_URL:
    'https://xdr18ajfu3.execute-api.us-east-1.amazonaws.com/Prod/usernameexist',

  CORS_PROXY_URL: 'https://1qmd8jteh1.execute-api.us-east-1.amazonaws.com',

  GET_CHAT_BY_ID_URL:
    NZ_CORE_SERVICES_REST_URL ??
    'https://core-services-dev.nizza.com/api/v1/global-page/chat',
  GET_HIGHTLIGHT_BY_ID_URL:
    NZ_CORE_SERVICES_REST_URL ??
    'https://core-services-dev.nizza.com/api/v1/global-page/highlight-products',
  API_PLATFORM:
    NZ_CORE_SERVICES_REST_URL ?? 'https://core-services-dev.nizza.com/api/v1',
  GET_INFO_ACCOUNT_URL:
    NZ_CORE_SERVICES_REST_URL ??
    'https://core-services-dev.nizza.com/api/v1/accounts/public',
};

const prod = {
  USERNAME_EXIST_URL:
    'https://9n976nhd6g.execute-api.us-east-1.amazonaws.com/Prod/usernameexist',

  CORS_PROXY_URL: 'https://3hvqfl2xcg.execute-api.us-east-1.amazonaws.com',

  GET_CHAT_BY_ID_URL:
    'https://b133h34s56.execute-api.us-east-1.amazonaws.com/global-page/chat',
  GET_HIGHTLIGHT_BY_ID_URL:
    'https://b133h34s56.execute-api.us-east-1.amazonaws.com/global-page/highlight-products',
  API_PLATFORM:
    NZ_BACKOFFICE_BACK_URL ??
    'https://b133h34s56.execute-api.us-east-1.amazonaws.com',
  GET_INFO_ACCOUNT_URL:
    'https://core-services-prod.nizza.com/api/v1/accounts/public',
};

export const config = (environment: string) =>
  environment === 'prod' ? prod : dev;
